import {Tabs} from '@wandb/components';
import React, {useMemo} from 'react';

import {type DrawerContentType} from '../../WorkspaceDrawerContextProvider';
import {SettingsContentWrapper} from '../components/SettingsContentWrapper';
import {
  SECTION_LINE_PLOT_SETTINGS_DESCRIPTION,
  WORKSPACE_LINE_PLOT_SETTINGS_DESCRIPTION,
} from '../constants';
import {LinePlotDataTab} from './LinePlotDataTab';
import {LinePlotDisplayPreferencesTab} from './LinePlotDisplayPreferencesTab';
import {useLinePlotSettingsContext} from './LinePlotSettingsContextProvider';

export const LinePlotSettings = ({
  contentHeader,
  displayedContentType,
}: {
  contentHeader?: React.ReactNode;
  displayedContentType: DrawerContentType;
}) => {
  const {settingLevel} = useLinePlotSettingsContext();
  const items = useMemo(
    () => [
      {
        id: 'data',
        label: 'Data',
        content: <LinePlotDataTab />,
      },
      {
        id: 'display',
        label: 'Display preferences',
        content: (
          <LinePlotDisplayPreferencesTab
            displayedContentType={displayedContentType}
          />
        ),
      },
    ],
    [displayedContentType]
  );

  const description =
    settingLevel === 'workspace'
      ? WORKSPACE_LINE_PLOT_SETTINGS_DESCRIPTION
      : SECTION_LINE_PLOT_SETTINGS_DESCRIPTION;

  return (
    <SettingsContentWrapper
      title="Line plots"
      description={description}
      header={contentHeader}>
      <Tabs aria-label="Line plot settings" items={items} />
    </SettingsContentWrapper>
  );
};
